/**
 * @generated SignedSource<<6f162ebbdd0c80b3c02608d500d945d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
import { FragmentRefs } from "relay-runtime";
export type buildStatusTypeFragment$data = {
  readonly canceledInfo: {
    readonly __typename: "Comment";
  } | null | undefined;
  readonly failedToStart: boolean | null | undefined;
  readonly state: BuildState | null | undefined;
  readonly status: string | null | undefined;
  readonly " $fragmentType": "buildStatusTypeFragment";
};
export type buildStatusTypeFragment$key = {
  readonly " $data"?: buildStatusTypeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"buildStatusTypeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "buildStatusTypeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "canceledInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "failedToStart",
      "storageKey": null
    }
  ],
  "type": "Build",
  "abstractKey": null
};

(node as any).hash = "b139493ae70b37277c23dcd55a596375";

export default node;
